import React from 'react'
import { Package, Phone } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { usePhoneNumber } from "../hooks/usePhoneNumber";

const StaticNavbar = () => {
  const location = useLocation();

  // Pass current route pathname to your hook
  const phoneNumber = usePhoneNumber(location.pathname);

  return (
    <nav className="navbar bg-[#1A1A1A] sticky top-0 z-40 shadow-nav">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          
          {/* Logo */}
          <div className="flex items-center flex-shrink-0">
            <Link to="/" className="flex items-center space-x-2">
              <img
                src="/images/new_header_logo.png"
                alt="Golden Sparrow"
                className="h-16 w-auto object-contain"
              />
            </Link>
          </div>

          {/* Dynamic Phone */}
          <div className="flex items-center gap-2">
            <button
              className="gradient-btn"
              onClick={() => { window.location.href = `tel:${phoneNumber}` }}
            >
              <div className="gradient-btn-content">
                <Phone className="w-4 h-4 mr-2" />
                <span className="hidden lg:flex">{phoneNumber}</span>
                <span className="flex sm:flex md:flex lg:hidden">Call Now</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default StaticNavbar;
